{
  "name": "12-Sabat II JI Well Temperament",
  "description": "12-tone Rational Intonation Well Temperament, derived from harmonic partial row intervals limited to the prime subgroup of 2, 3, 5, and 17, 19. Seven diatonic notes and F are tuned Pythagorean, allowing the historical Persian Arabic schisma tunings to be applied. A and D are added as major thirds, and the two remaining tones are divided evenly using 16:17.",
  "scale": [
    "16/15",
    "9/8",
    "81/68",
    "81/64",
    "4/3",
    "729/512",
    "3/2",
    "51/32",
    "27/16",
    "3645/2048",
    "243/128",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-WT-SabatII",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": ["C", "D", "D", "E", "E", "F", "F", "G", "G", "A", "A", "B"],
  "note_colors": [
    "#ffdbdb",
    "#c7c1a1",
    "#ffffff",
    "#c6c6c6",
    "#ffffff",
    "#ffffff",
    "#dee2da",
    "#ffffff",
    "#cfcfcf",
    "#ffffff",
    "#e6e0cb",
    "#ffffff"
  ],
  "equivSteps": 12,
  "fundamental": 440,
  "reference_degree": 9,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
